import { render, staticRenderFns } from "./secondClass.vue?vue&type=template&id=2215cee4&scoped=true&"
import script from "./secondClass.vue?vue&type=script&lang=js&"
export * from "./secondClass.vue?vue&type=script&lang=js&"
import style0 from "./secondClass.vue?vue&type=style&index=0&id=2215cee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215cee4",
  null
  
)

export default component.exports